import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal } from 'react-bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-imprensa-oficial.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Tooltip,
  Stack,
  Checkbox,
  IconButton,
  RadioGroup,
  Radio,
  TagLabel,
  Tag,
  Wrap,
  TagCloseButton,
  WrapItem,
} from '@chakra-ui/react';
import { ImagePdfDropzone } from '../../../../components/common/imagePdfDropzone/imagePdfDropzone';
import { PdfViewerIframe } from '../../../../components/common/PdfViewer';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/imprensaOficial';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { obterUsuario } from '../../../../api/usuario';
import { FaPlus } from 'react-icons/fa';
import { listarSecretariasAtivas } from '../../../../api/secretarias';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const InserirImprensaOficial: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    imagem: { value: string; error: boolean };
    creditoAutorImprensaOficial: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    imagem: { value: '', error: false },
    creditoAutorImprensaOficial: { value: '', error: false },

    descricaoImagem: { value: '', error: false },
    categoriaId: { value: '', error: false },
    secretariaId: { value: [], error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },

  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [paginas, setPaginas] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [secretariasAtivas, setSecretariasAtivas] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [nomeArquivo, setNomeArquivo] = useState<any>();
  const [typeMidia, setTypeMidia] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);

  
  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  
    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };
    
    const listarSecretarias = async () => {
      try {
        const data = await listarSecretariasAtivas();
        setSecretariasAtivas(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };
  
    listarSecretarias();
    fetchCategorias();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);  

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };



  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked ? [...prev, seqPagina] : prev.filter((id) => id !== seqPagina);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina]
        : prevValues.paginaId.value.filter((id: number) => id !== seqPagina);

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
        ordemBanner: { value: 0 },
      };
    });
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev =>
      checked ? Array.from(new Set([...prev, codSecretaria])) : prev.filter(id => id !== codSecretaria)
    );
  
    setFormValues(prev => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);
  
      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };  





  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const isPdf = selected.type === "application/pdf";

      setNomeArquivo(selected.name);
      setTypeMidia(selected.type);
      setArquivo(selected);
      setArquivoSelecionado(selected);

      // Para PDFs, não preencher imageBase64 para que o componente mostre o ícone de PDF
      if (isPdf) {
        setImageBase64("");
      } else {
        // Para imagens, converter para base64
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === "string") {
            const novaUrl = atualizarPreview(reader.result);
            setImageBase64(novaUrl);
            setFormValues((prev) => ({
              ...prev,
              imagem: { value: novaUrl, error: false },
            }));
          }
        };
        reader.readAsDataURL(selected);
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      setImageBase64("");
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const handleInputRadioChange = (field: string, value: any) => {
    setFormValues({
      ...formValues,
      [field]: { error: false, value }
    });
  };

  const isFormValid = () => {
    const { titulo, data, categoriaId, paginaId } = formValues;

    const isValid = (
      titulo.value &&
      data.value &&
      categoriaId.value &&
      paginaId.value.length > 0
    );
    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);
  
    const {
      creditoAutorImprensaOficial,
      descricaoImagem,
      categoriaId,
      secretariaId,
      paginaId,
      usuarioId,
      titulo,
      data
    } = formValues;
  


    const pendencia = usuarioId.value
      ? {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
        }
      : null;
  
           let codSituacao = 1;
;
  
    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (pendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    const params: PublicacaoParams = {
      codTipoPublicacao: 5,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: null,
      seqUsuario: seqUsuario,
      binPublicacao: '',
      dscResumo: null,
      urlBin: null,
      dscPublicacao: null,
      dscCreditoImagem: null,
      dscCreditoNoticia: creditoAutorImprensaOficial.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      seqCategoria: Number(categoriaId.value) || null,
      conteudoPaginaDTO: paginaId.value.map((id: any) => ({
        seqPagina: Number(id),
        numOrdem: 0,
      })),
      pendencia: pendencia,
      numAprovacao: pendencia ? 1 : 0,
      dscCitacaoUsuario: null,
      numAprovado: 0,
      codSituacaoPubli: codSituacao,
      datInicioEvento: null,
      datFimEvento: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscTags: null,
      numRegistro: 1,
      contasRedeSocial: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };

    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        formData.append("file", arquivoSelecionado);

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'imprensa-oficial';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirImprensaOficialNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
  
        params.binPublicacao = cdnUrl;
      }

      setLoadingButton(false);
      await api.inserirPublicacao(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Imprensa oficial inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/imprensa-oficial');
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao inserir imprensa oficial:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao inserir imprensa oficial. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/imprensa-oficial');
      });
    }
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      backgroundColor='#fafafa'
      width='100%'
      height='100%'
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Criar imprensa oficial
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Categoria da Imprensa Oficial</FormLabel>
                <Select
                  placeholder='Selecione uma Categoria'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.categoriaId.value}
                  onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                >
                  {categorias.length > 0 ? (
                    categorias.map(categoria => (
                      <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                        {categoria.dscCategoria}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Número da Publicação</FormLabel>
                <CustomInput
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite o número da publicação"
                />
              </FormControl>
            </div>

            <div className="col-md-3 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Data para Publicação</FormLabel>
                <CustomInput
                  id="official-media-insert-publication-date"
                  type="date"
                  value={formValues.data.value}
                  onChange={(e) => handleFieldChange('data', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>


          </div>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl className="mb-4">
                <FormLabel mb="8px">Arquivo do Diário Oficial</FormLabel>
                <ImagePdfDropzone
                  onFileSelected={handleImageSelected}
                  base64={imageBase64}
                  height={300}
                  uploadMessage={`Arraste uma imagem ou PDF aqui ou clique para selecionar.`}
                />
              </FormControl>

              {imageBase64 && (
                <FormControl isRequired className="mb-4">
                  <PdfViewerIframe 
                    pdfUrl={imageBase64} 
                    buttonLabel="Visualizar PDF"
                    modalTitle="Visualização da Imprensa Oficial"
                  />
                </FormControl>
              )}

              <FormControl>
                <Flex justify="space-between" align="center" mb="8px">
                  <FormLabel mb="8px">
                    Escolha em quais páginas a imprensa oficial deve aparecer <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                </Flex>
                <div className="input-radio-lista">
                  <Stack spacing={5}>
                    {paginas.length > 0 ? (
                      paginas.map((pagina: any) => (
                        <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                          <Checkbox
                            className="checkPaginasImprensaOficial"
                            isChecked={selectedPages.includes(pagina.seqPagina)}
                            onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                          >
                            {pagina.nomPagina}
                          </Checkbox>
                        </Flex>
                      ))
                    ) : (
                      <p>Não há páginas disponíveis.</p>
                    )}
                  </Stack>
                </div>
              </FormControl>
            </div>
          </div>

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/imprensa-oficial')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Criando Imprensa Oficial..."
            >
              Criar Imprensa Oficial
            </Button>
          </Flex>
        </form>
      </Box>

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default InserirImprensaOficial;
